import {
  authReq
} from '@/utils/http'

const listCoupon = (data) => {
  return authReq.get('/api/v1/activities/coupon', {
    page: data.page,
    'page_size': data.pageSize,
    sort: data.sort,
    ...data.filters
  })
}

const listGift = (data) => {
  return authReq.get('/api/v1/activities/gift', {
    page: data.page,
    'page_size': data.pageSize,
    sort: data.sort,
    ...data.filters
  })
}

export default {
  listCoupon,
  listGift
}



// WEBPACK FOOTER //
// ./src/api/activityApi.js